import React, { useReducer } from "react";
import CssBaseline from "@material-ui/core/CssBaseline";
import { ThemeProvider } from "@material-ui/styles";
import {
  HashRouter as Router,
  Redirect,
  Route,
  Switch,
} from "react-router-dom";
import {
  AdminRoute,
  MemberRoute,
  MessageBarProvider,
  RootEventWrapper,
} from "./components";
import { UrlConst } from "./constants";
import {
  FTSearchDispatchContext,
  ftsearchContextInitData,
  FTSearchReducer,
  FTSearchContext,
  STSearchDispatchContext,
  stsearchContextInitData,
  STSearchReducer,
  STSearchContext,
  VirtualFolderDispatchContext,
  virtualFolderContextInitData,
  VirtualFolderReducer,
  virtualFolderContextData,
  getSelfUser,
  LoginApi,
  setSelfUserWithToken,
  UsersApi
} from "./helpers";
import {
  ConnectionConfigPage,
  DictionaryConfigPage,
  UserConfigPage,
  UserGroupConfigPage,
} from "./pages/ConfigPage";
import { SelfPasswordChangePage } from "./pages/ConfigPage/self/SelfPasswordChangePage";
import { LoginPage } from "./pages/LoginPage";
import { NotificationPage } from "./pages/NotificationPage";
import { FTSearchPage, STSearchPage } from "./pages/SearchPage";
import { VirtualFolderPage } from "./pages/VirtualFolderPage";
import SSearchAdminTheme from "./styles/SSearchAdminTheme";
import SSearchTheme from "./styles/SSearchTheme";

const ContextWrapper = (props: { children: React.ReactNode }) => {
  const { children } = props;

  // 全文検索画面検索条件
  const [
    fullTextSearchRequestOptionState,
    fullTextSearchRequestOptionDispatch,
  ] = useReducer(FTSearchReducer, ftsearchContextInitData);

  // 類似検索画面検索条件
  const [
    similarityTextSearchRequestOptionState,
    similarityTextSearchRequestOptionDispatch,
  ] = useReducer(STSearchReducer, stsearchContextInitData);

  // 仮想フォルダ―画面検索条件
  const [
    virtualFolderRequestOptionState,
    virtualFolderRequestOptionDispatch,
  ] = useReducer(VirtualFolderReducer, virtualFolderContextInitData);

  return (
    <ThemeProvider theme={SSearchTheme}>
      <CssBaseline />
      <FTSearchContext.Provider value={fullTextSearchRequestOptionState}>
        <FTSearchDispatchContext.Provider
          value={fullTextSearchRequestOptionDispatch}
        >
          <STSearchContext.Provider
            value={similarityTextSearchRequestOptionState}
          >
            <STSearchDispatchContext.Provider
              value={similarityTextSearchRequestOptionDispatch}
            >
              <virtualFolderContextData.Provider
                value={virtualFolderRequestOptionState}
              >
                <VirtualFolderDispatchContext.Provider
                  value={virtualFolderRequestOptionDispatch}
                >
                  <MessageBarProvider>{children}</MessageBarProvider>
                </VirtualFolderDispatchContext.Provider>
              </virtualFolderContextData.Provider>
            </STSearchDispatchContext.Provider>
          </STSearchContext.Provider>
        </FTSearchDispatchContext.Provider>
      </FTSearchContext.Provider>
    </ThemeProvider>
  );
};

const Root = () => {
  return (
    <ContextWrapper>
      <RootEventWrapper>
          <Router>
            <Switch>
              {/* <Route path="/admin">
                <ThemeProvider theme={SSearchAdminTheme}>
                  <Admin />
                </ThemeProvider>
              </Route> */}
              <Route path="/">
                <ThemeProvider theme={SSearchTheme}>
                  <Default />
                </ThemeProvider>
              </Route>
            </Switch>
          </Router>
      </RootEventWrapper>
    </ContextWrapper>
  );
};

// admin
function Admin() {
  return (
    <Switch>
      <AdminRoute path={UrlConst.admin.userConfig}>
        <UserConfigPage />
      </AdminRoute>
      <AdminRoute path={UrlConst.admin.userGroupConfig}>
        <UserGroupConfigPage />
      </AdminRoute>
      <AdminRoute path={UrlConst.admin.connectionConfig}>
        <ConnectionConfigPage />
      </AdminRoute>
      <AdminRoute path={UrlConst.admin.dictionaryConfig}>
        <DictionaryConfigPage />
      </AdminRoute>
      <AdminRoute path={UrlConst.admin.notification}>
        <NotificationPage />
      </AdminRoute>
    </Switch>
  );
}

// default
function Default() {
  return (
    <Switch>
      {/* <MemberRoute path={UrlConst.member.fullTextSearch}>
        <FTSearchPage />
      </MemberRoute> */}
      {/* <MemberRoute path={UrlConst.member.similarityTextSearch}>
        <STSearchPage />
      </MemberRoute> */}
      <MemberRoute path={UrlConst.member.virtualFolder}>
        <VirtualFolderPage />
      </MemberRoute>
      <MemberRoute path={UrlConst.member.virtualFolderAdmin}>
        <VirtualFolderPage isAdmin/>
      </MemberRoute>

      {/* Auth */}
      <Route path="/auth/login" component={LoginPage} />

      {/* User */}
      {/* <MemberRoute path={UrlConst.self.changePassword}>
        <SelfPasswordChangePage />
      </MemberRoute> */}

      {/* 初期表示 */}
      <Route
        path="/"
        render={() => {
          // レンダー時にユーザーを取得して初期表示画面に遷移する
          const user = getSelfUser();
          return user && user.is_admin ? (
            <Redirect to={UrlConst.admin.userConfig} />
          ) : (
            // [HP稼働]: electronからの修正(初期ページを全文検索→仮想フォルダに変更)
            <Redirect to={UrlConst.member.virtualFolder} />
          );
        }}
      />
    </Switch>
  );
}

export default Root;
